import { Component } from '@angular/core';

@Component({
  selector: 'atomo-at-work',
  standalone: true,
  imports: [],
  templateUrl: './atomo-at-work.component.html',
  styleUrl: './atomo-at-work.component.scss'
})
export class AtomoAtWorkComponent {

}
